import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { upsertCartItem } from "../../../server/CollectSite";
import { setUserEntry } from "../../../server/Customer";
import { ShoppingCart } from "lucide-react";
import { use } from "react";
import { useEffect } from "react";

const ProductAddToCart = ({ element, haveInfo }) => {
  const dispatch = useDispatch();
  const { user, role, productsInCart, stationId } = useSelector((state) => ({
    role: state.user.role,
    user: state.user.user,
    productsInCart: state.productsInCart.productsInCart,
    stationId: state.user.stationId,
  }));

  const productId = element.productId;

  const inCart = productsInCart.find((item) => item.productId === productId);

  useEffect(() => {
    console.log("Product in cart:", inCart);
  }, [inCart]);
  const callUpsertCartItem = (element, quantity, stationId) => {
    console.log("callUpsertCartItem called with:", {
      element,
      quantity,
      stationId,
    });
    if (!user || user.UserTypeId === 5) {
      dispatch(setUserEntry([true, "login"]));
    } else {
      console.log("hhh", element);
      const finalPrice = parseFloat(element.pricing.price).toFixed(2);
      //TODO:handle promo price here
      // ? parseFloat(element.SalePrice).toFixed(2)
      // : element.Price;
      //צריך לשלוח גם מזהה של הווריאנט אם קיים
      dispatch(
        upsertCartItem(
          productId,
          finalPrice,
          quantity * weightJump,
          String(stationId)
        )
      );
    }
    // else {
    //   console.log("final price nuw ")
    //   const finalPrice = parseFloat(
    //    element.SalePrice || element.unitPrice || element.Price
    //  ).toFixed(2);
    //   //צריך לשלוח גם מזהה של הווריאנט אם קיים
    //   dispatch((upsertCartItem(finalProductId, finalPrice, quantity, stationId+"")));

    // }
  };

  // const weightJump = element.weightJump > 0 ? element.weightJump : 1;
  const weightJump = element?.weightJump > 0 ? element.weightJump : 1;
  return (
    <div className={inCart ? "add-to-cart in-cart" : "add-to-cart not-in-cart"}>
      {!role &&
      (element.availability?.["availableQuantity"] >= weightJump ||
        (inCart && inCart.quantity > 0)) ? (
        <div
          className="wrap"
          // onClick={
          //   !inCart ? () => callUpsertCartItem(element, 1, stationId) : null
          // }
        >
          {inCart && inCart.quantity > 0 ? (
            <>
              <div
                className="add-btn"
                onClick={
                  inCart &&
                  (!haveInfo ||
                    inCart.availability?.["availableQuantity"] >= weightJump)
                    ? () =>
                        callUpsertCartItem(
                          inCart.product,
                          (inCart?.quantity || 0) + 1,
                          stationId
                        )
                    : null
                }
              >
                <p>+</p>
              </div>
              <div className="col-lg-7">
                <input
                  readOnly
                  type="text"
                  value={inCart.quantity}
                  disabled={true}
                />
              </div>
              <div
                className="minus-btn"
                onClick={
                  inCart
                    ? () =>
                        callUpsertCartItem(
                          inCart.product,
                          inCart.quantity - 1,
                          stationId
                        )
                    : null
                }
              >
                <p>-</p>
              </div>
            </>
          ) : (
            <p
              onClick={
                inCart && (!haveInfo || element.QuantityCanOrder >= weightJump)
                  ? () => callUpsertCartItem(element, 1, stationId)
                  : null
              }
            >
              <ShoppingCart size={24} />
            </p>
          )}
        </div>
      ) : (
        inCart &&
        inCart?.quantity == 0 && <div className="outOfStock">אזל מהמלאי</div>
      )}
    </div>
  );
};

export default ProductAddToCart;
